import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "close-custom-panal" }
const _hoisted_2 = { class: "close-custom-panal__content" }

import { NSpace, NButton } from 'naive-ui'
import { Type } from 'naive-ui/es/button/src/interface'
interface Emits {
  (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'commonConfirmDialog',
  props: {
    onOK: null,
    onCancel: null,
    content: null,
    confirmButtonText: null,
    confirmButtonType: null,
    cancelButtonText: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  onOK: () => void
  onCancel?: () => void
  content: string
  confirmButtonText: string
  confirmButtonType?: Type
  cancelButtonText?: string
}



const close = () => {
  props.onCancel && props.onCancel()
  emit('close')
}
const confirm = () => {
  props.onOK()
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.content), 1),
    _createVNode(_unref(NSpace), {
      justify: "end",
      class: "close-custom-panal__footer"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(NButton), {
            onClick: close,
            class: "close-custom-panal__footer-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.cancelButtonText || '取消'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(NButton), {
            type: __props.confirmButtonType || 'error',
            onClick: confirm,
            class: "close-custom-panal__footer-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.confirmButtonText), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})